import PrintIcon from "@mui/icons-material/Print";
import {Button} from "@mui/material";
import pdfMake from 'pdfmake/build/pdfmake.js';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import {useFormikContext} from "formik";
import {useSelector} from "react-redux";
import buildCar from "./printParts/buildCar";
import buildJobs from "./printParts/buildJobs";
import buildDetails from "./printParts/buildDetails";
import {header} from "./printParts/header";
import {signatures} from "./printParts/signatures";
import {styles} from "./printParts/styles";
import {
    detailsFinalSum,
    filterDetailsFromJobs,
    filterJobs,
    jobsFinalSum,
    jobsFinalVat,
    detailsFinalVat
} from "./TableSums";
import printDopCarInfo from "./printParts/printDopCarInfo";
import buildClient from "./printParts/buildClient";
import {buildCompanyInfo} from "./printParts/buildCompanyInfo.js";

import { useMemo} from "react";
import {useTranslation} from "react-i18next";
import buildJobsTips from "./printParts/buildJobsTips";

export default function Print() {
    let {values} = useFormikContext();
    const { i18n } = useTranslation();
    const currentLang = i18n.language.split('-')[0];

    const mileage = useSelector(state => state.carProps.info.mileage);
    const vin = useSelector(state => state.carProps.info.vin);
    const plate = useSelector(state => state.carProps.info.plate);
    const mileageType = useSelector(state => state.carProps.info.mileageType);
    const mileageOptions = useSelector(state => state.settings.mileageOptions);



    const rawJobs = useSelector(state => state.jobs.jobs);
    const jobs = filterJobs(rawJobs);
    const details = filterDetailsFromJobs(jobs);

    const showComplexity = useSelector(state => state.settings.showComplexity);
    const showCarTable = useSelector(state => state.settings.showCarTable);
    const showClientTable = useSelector(state => state.settings.showClientTable);

    const printCar = buildCar(values);
    const printCarInfo = useMemo(() => {
        const selectedMileageTypeOption = mileageOptions.find(opt => opt.value === mileageType);
        const dopCarInfo = {
            mileage,
            vin,
            plate,
            mileageType: selectedMileageTypeOption ? selectedMileageTypeOption.label[currentLang] : null
        };
        return printDopCarInfo(dopCarInfo);
    }, [ mileage, mileageType, vin, plate]);

    const printClient = buildClient();
    const printJobs = buildJobs(jobs, showComplexity);
    const printRepairTipsJobs = buildJobsTips(jobs, showComplexity);
    const printDetails = details.length > 0 ? buildDetails(details) : null;

    // const jobsSum = jobs.reduce((sum, item) => sum + Number(Math.round(item.sdh_hour * item.hourPrice * item.difficulty * 100) / 100), 0)
    // const detailsSum = details.reduce((sum,item) => sum + Number(Math.round(item.amount * item.price * 100) / 100), 0)

    const totalSum = detailsFinalSum({useVat: true}) + jobsFinalSum({useVat: true});
    const totalVat = detailsFinalVat() + jobsFinalVat();

    const document = {
        styles: styles,

        header: header,

        content: [
            {
                text: 'Заказ-наряд от ' + (new Date()).toLocaleDateString(),
                alignment: 'center',
                style: 'header'
            },
            printCar,
            showCarTable ? printCarInfo : null,
            showClientTable ? printClient : null,
            printJobs,
            printDetails,
            {
                stack: [
                    {
                        columns: [
                            {
                                text: 'Итого к оплате:',
                                width: '20%',
                                bold: true
                            },
                            {
                                text: totalSum.toFixed(2) + ' руб.',
                                width: '20%',
                                alignment: 'right',
                                bold: true
                            }
                        ]
                    },
                    {
                        columns: [
                            {
                                text: 'В том числе НДС:',
                                width: '20%',
                            },
                            {
                                text: totalVat.toFixed(2) + ' руб.',
                                width: '20%',
                                alignment: 'right',
                            }
                        ]
                    }
                ]
            },
            signatures,
            printRepairTipsJobs
        ],
    };

    return (
        <Button variant={'outlined'}
                onClick={() => {
                    let doc = document;
                    buildCompanyInfo().then(companyInfo => {
                        doc = {
                            ...document,
                            content: [...companyInfo, ...document.content],
                        };
                    }).finally(() => {
                        pdfMake.vfs = pdfFonts.vfs;
                        pdfMake.createPdf(doc).open();
                    });
                }}
                size={'small'}
                startIcon={<PrintIcon/>}
                sx={{mt: 1, ml: 1}}
        >
            {'Распечатать'}
        </Button>
    )
}